export default __webpack_public_path__ + "static/media/Adelaide-Soderborg.bfbe1423.jpg";